export const raw_material_order_item_statuses =  [
  {id:0, name: 'Pending', color: '', visible: true},
  {id:1, name: 'Not Accepted', color: '#f8961e', visible: true},
  {id:2, name: 'Accepted', color: '#f8961e', visible: true},
  {id:3, name: 'Pending Dispatch', color: '#f9c74f', visible: true},
  {id:4, name: 'Not Dispatched', color: '#f72585', visible: true},
  {id:5, name: 'Dispatched', color: '#006d77', visible: true},
  {id:6, name: 'Not Received', color: '#f72585', visible: true},
  {id:7, name: 'Received', color: '#006d77', visible: true},
  {id:7, name: 'Received - QC Passed', color: '#006d77', visible: false},
  {id:7, name: 'Received - QC Rejected', color: '#d62828', visible: false},
  {id:8, name: 'Returned', color: '#3a0ca3', visible: true},
  {id:9, name: 'Cancelled', color: '#d62828', visible: true},
];

export const raw_material_order_statuses =  [
  {id: 2, name: 'All Accepted', slug: 'all_accepted', color: '#f8961e', is_partial_status: false,
    before_status: ['Order Submitted'], item_status: ''
  },
  {id: 3, name: 'Part Accepted', slug: 'part_accepted', color: '#f9844a', is_partial_status: true,
    before_status: ['Order Submitted', 'Part Accepted'], item_status: ''
  },
  {id: 4, name: 'Pending Dispatch', slug: 'pending_dispatch', color: '#f9c74f', is_partial_status: false,
    before_status: ['Part Accepted', 'All Accepted'], item_status: ''
  },
  {id: 5, name: 'All Dispatched', slug: 'all_dispatched', color: '#006d77', is_partial_status: false,
    before_status: ['Pending Dispatch'], item_status: ''
  },
  {id: 6, name: 'Part Dispatched', slug: 'part_dispatched', color: '#219ebc', is_partial_status: true,
    before_status: ['Pending Dispatch', 'Part Dispatched'], item_status: 'Not Dispatched'
  },
  {id: 7, name: 'All Received', slug: 'all_received', color: '#006d77', is_partial_status: false,
    before_status: ['All Dispatched'], item_status: ''
  },
  {id: 8, name: 'Part Received', slug: 'part_received', color: '#d62828', is_partial_status: true,
    before_status: ['All Dispatched', 'Part Dispatched', 'Part Received'], item_status: 'Not Received'
  },
  {id: 9, name: 'All Returned', slug: 'all_return', color: '#3a0ca3', is_partial_status: false,
    before_status: ['All Received'], item_status: ''
  },
  {id: 10, name: 'Part Returned', slug: 'part_return', color: '#3a0ca3', is_partial_status: true,
    before_status: ['All Received', 'Part Received', 'Part Returned'], item_status: 'Not Returned'
  },
  {id: 11, name: 'Goods Not Received', slug: 'goods_not_received', color: '#f72585', is_partial_status: false,
    before_status: ['All Dispatched', 'Part Dispatched'], item_status: ''
  },
  {id: 12, name: 'Order Cancelled', slug: 'order_cancelled', color: '#d62828', is_partial_status: false,
    before_status: ['Order Submitted'], item_status: ''
  },
]

export const sundry_item_order_item_statuses =  [
  {id:0, name: 'Pending', color: ''},
  {id:1, name: 'Not Accepted', color: '#f8961e'},
  {id:2, name: 'Accepted', color: '#f8961e'},
  {id:3, name: 'Pending Dispatch', color: '#f9c74f'},
  {id:4, name: 'Not Dispatched', color: '#f72585'},
  {id:5, name: 'Dispatched', color: '#006d77'},
  {id:6, name: 'Not Received', color: '#f72585'},
  {id:7, name: 'Received', color: '#006d77'},
  {id:8, name: 'Returned', color: '#3a0ca3'},
  {id:9, name: 'Cancelled', color: '#d62828'},
];

export const sundry_item_order_statuses =  [
  {id: 2, name: 'All Accepted', slug: 'all_accepted', color: '#f8961e', is_partial_status: false,
    before_status: ['Order Submitted'], item_status: ''
  },
  {id: 3, name: 'Part Accepted', slug: 'part_accepted', color: '#f9844a', is_partial_status: true,
    before_status: ['Order Submitted', 'Part Accepted'], item_status: ''
  },
  {id: 4, name: 'Pending Dispatch', slug: 'pending_dispatch', color: '#f9c74f', is_partial_status: false,
    before_status: ['Part Accepted', 'All Accepted'], item_status: ''
  },
  {id: 5, name: 'All Dispatched', slug: 'all_dispatched', color: '#006d77', is_partial_status: false,
    before_status: ['Pending Dispatch'], item_status: ''
  },
  {id: 6, name: 'Part Dispatched', slug: 'part_dispatched', color: '#219ebc', is_partial_status: true,
    before_status: ['Pending Dispatch', 'Part Dispatched'], item_status: 'Not Dispatched'
  },
  {id: 7, name: 'All Received', slug: 'all_received', color: '#006d77', is_partial_status: false,
    before_status: ['All Dispatched'], item_status: ''
  },
  {id: 8, name: 'Part Received', slug: 'part_received', color: '#d62828', is_partial_status: true,
    before_status: ['All Dispatched', 'Part Dispatched', 'Part Received'], item_status: 'Not Received'
  },
  {id: 9, name: 'All Returned', slug: 'all_return', color: '#3a0ca3', is_partial_status: false,
    before_status: ['All Received'], item_status: ''
  },
  {id: 10, name: 'Part Returned', slug: 'part_return', color: '#3a0ca3', is_partial_status: true,
    before_status: ['All Received', 'Part Received', 'Part Returned'], item_status: 'Not Returned'
  },
  {id: 11, name: 'Goods Not Received', slug: 'goods_not_received', color: '#f72585', is_partial_status: false,
    before_status: ['All Dispatched', 'Part Dispatched'], item_status: ''
  },
  {id: 12, name: 'Order Cancelled', slug: 'order_cancelled', color: '#d62828', is_partial_status: false,
    before_status: ['Order Submitted'], item_status: ''
  },
]


export const product_order_item_statuses =  [
  {id:0, name: 'Pending', color: '', is_visible: true, before_status: ['Submitted', ''], label: 'Ordered item accept'},
  {id:1, name: 'In-Manufacturing', color: '#f8961e', is_visible: false, before_status: ['Pending'], label: 'In-Manufacturing'},
  {id:2, name: 'In-QC', color: '#f8961e', is_visible: false, before_status: ['In-Manufacturing'], label: 'In-QC'},
  {id:3, name: 'In-Dispatch', color: '#0AB8B5', is_visible: true, before_status: ['In-QC'], label: 'In-Dispatch'},
  {id:4, name: 'Dispatched', color: '#006d77', is_visible: true, before_status: ['In-Dispatch'], label: 'Dispatched'},
  {id:5, name: 'Customer-Received', color: '#006d77', is_visible: true, before_status: ['Dispatched'], label: 'Customer-Received'},
  {id:6, name: 'Returned', color: '#f72585', is_visible: true, before_status: ['Customer-Received'], label: 'Returned'},
  {id:7, name: 'Goods-Lost', color: '#f72585', is_visible: true, before_status: ['Dispatched'], label: 'Goods-Lost'},
  {id:8, name: 'Cancelled', color: '#d62828', is_visible: true, before_status: ['Submitted', '', 'Pending' ], label: 'Ordered item reject'},
  {id:8, name: 'Submitted', color: '#E98D00', is_visible: false, before_status: [], label: 'Submitted'},
];


export const product_order_statuses =  [
  {id: 1, name: 'Submitted', slug: 'submitted', color: '#f8961e',
    before_status: [], visible_on_main_status: false, label: '',
  },
  {id: 2, name: 'Pending', slug: 'pending', color: '#f9844a',
    before_status: ['Submitted'], visible_on_main_status: false, label: '',
  },
  {id: 3, name: 'In-Manufacturing', slug: 'in_manufacturing', color: '#f9c74f',
    before_status: ['Pending'], visible_on_main_status: false, label: '',
  },
  {id: 4, name: 'In-QC', slug: 'in_qc', color: '#006d77',
    before_status: ['In-Manufacturing'], visible_on_main_status: false, label: '',
  },
  {id: 5, name: 'In-Dispatch', slug: 'in_dispatch', color: '#219ebc',
    before_status: ['In-QC'], item_status: 'Not Dispatched', visible_on_main_status: false, label: '',
  },
  {id: 6, name: 'Dispatched', slug: 'dispatched', color: '#006d77',
    before_status: ['In-Dispatch'], visible_on_main_status: false, label: '',
  },
  {id: 7, name: 'Customer-Received', slug: 'customer_received', color: '#d62828',
    before_status: ['Dispatched'], visible_on_main_status: false, label: '',
  },
  {id: 8, name: 'Returned', slug: 'returned', color: '#3a0ca3',
    before_status: ['Customer-Received'], visible_on_main_status: false, label: '',
  },
  {id: 9, name: 'Goods-Lost', slug: 'goods_lost', color: '#f72585',
    before_status: ['In-Dispatch'], visible_on_main_status: false, label: '',
  },
  {id: 10, name: 'Cancelled', slug: 'cancel', color: '#d62828',
    before_status: ['Submitted', 'Pending'], visible_on_main_status: true, label: 'Reject',
  },
]

export const production_line_statuses = [
  {id: 1, name: 'Pre-Deployment Stage', url: 'pre_deployment_stage', color: 'warning'},
  {id: 2, name: 'Live', url: 'live', color: 'primary'},
  {id: 3, name: 'Offline for Maintenance', url: 'offline', color: 'danger'},
  {id: 4, name: 'Obsolete', url: 'obsolete', color: 'dark'},
]

export const work_order_statuses = [
  {id: 1, name: 'Open', color: 'warning', is_visible: false, url: 'open'},
  {id: 2, name: 'Confirmed to manufacturing plan', color: 'primary', is_visible: true, url: 'confirm', before_statuses: ['Open']},
  {id: 3, name: 'Cancel', color: 'danger', is_visible: true, url: 'cancel', before_statuses: ['Open', 'Confirmed', 'In Progress']},
  {id: 4, name: 'In Progress', color: 'success', is_visible: false, url: 'in_manufacturing', before_statuses: ['Confirmed']},
  {id: 5, name: 'Paused', color: 'warning', is_visible: false, url: 'pause', before_statuses: ['In Progress']},
  {id: 6, name: 'Stopped', color: 'danger', is_visible: false, url: 'stop', before_statuses: ['In Progress']},
  {id: 7, name: 'Mix Complete', color: 'success', is_visible: false, url: 'complete', before_statuses: []},
  {id: 8, name: 'Pack Off In Progress', color: 'success', is_visible: false, url: 'in-progress', before_statuses: []},
  {id: 9, name: 'Pack Off Completed', color: 'success', is_visible: false, url: 'in-progress', before_statuses: []},
]

export const partner_customer_agreement_statuses =  [
  { name: 'Active', color: 'success', is_visible: true, before_status: ['Suspended'], label: 'Activate'},
  { name: 'Suspended', color: 'warning', is_visible: true, before_status: ['Active', 'Pending'], label: 'Suspend'},
];
export const partners_statuses =  [
  { name: 'Active', color: 'success', is_visible: true, before_status: ['In-Active', 'Suspended'], label: 'Activate', key: 'active'},
  { name: 'Suspended', color: 'warning', is_visible: true, before_status: ['Active'], label: 'Suspend', key: 'in-active'},
];